module.exports = __webpack_public_path__ + "static/media/buch_iiw_tagfalter_seitlich.0838c7f6.jpg";